import React from 'react'
import ZionForm, { FormPlaceSuggest, FormTextField, useZionForm } from '@fs/zion-form'
import { ancestorCardFormResolver, ancestorCardOnSubmit } from '@fs/zion-homelands-shared'
import { Button, Row, Separator, usePageWidth } from '@fs/zion-ui'

export default function RecordSearchForm({ surname = '' }) {
  const atWidth = usePageWidth()
  const isMobile = atWidth({ default: true, lg: false })
  const methods = useZionForm({
    mode: 'all',
    defaultValues: {
      givenName: '',
      surname,
    },
    resolver: ancestorCardFormResolver,
  })

  const {
    formState: { isValid },
  } = methods

  const nameFieldProps = isMobile ? {} : { growX: true }

  return (
    <ZionForm methods={methods} onSubmit={ancestorCardOnSubmit('')}>
      <Separator size="xxs" />
      <Row>
        <FormTextField name="surname" label="Family Name" value={surname} {...nameFieldProps} />
        <FormTextField name="givenName" label="Given Name" {...nameFieldProps} />
      </Row>
      <FormPlaceSuggest label="Location" name="residence" placeholder="State or Province" />
      <Separator size="xxs" />
      <Button
        type="submit"
        emphasis="high"
        color="gray"
        fullWidth={atWidth({ default: true, md: false })}
        disabled={!isValid}
        linkName="Button:Search Records:Click"
      >
        Search
      </Button>
    </ZionForm>
  )
}
